export default class PwdToggle {
    constructor(trigger, w) {
        this.window = w || window;
        this.$trigger = $(trigger);
        this.$element = $(this.$trigger.data('pwdToggleTarget'));
    }

    click() {
        const inputType = this.$element.attr('type');
        if (inputType === 'password') {
            this.$element.attr('type', 'text');
            this.$trigger.find('span').removeClass('icon__icon-pwd-hidden').addClass('icon__icon-pwd-visible');
        } else {
            this.$element.attr('type', 'password');
            this.$trigger.find('span').removeClass('icon__icon-pwd-visible').addClass('icon__icon-pwd-hidden');
        }
    }

    setListeners() {
        this.$trigger
            .off('click', '', $.proxy(this, 'click'))
            .on('click', $.proxy(this, 'click'));
    }

    init() {
        this.setListeners();
    }

}
